// @flow
import React from 'react'
import { Link } from 'react-router-dom'
import { FormInput, ButtonPrimary, Checkbox } from 'src/common/components'
import { Field } from 'redux-form'
import { required, email } from 'src/helpers/formValidation'
import { StyledForm, StyledErrorBlock } from './loginFormStyles'

// types
import type { LoginPropsType } from 'src/modules/login/LoginTypes'

export default ({ handleSubmit, setUser, user: { loginErrors } }: LoginPropsType) => {
  return (
    <StyledForm>
      <div className="form-body">
        <div className="form-row">
          <label className="required">Email Address</label>
          <Field
            name="email"
            id="email"
            placeholder="Email"
            component={FormInput}
            validate={[required, email]}
          />
        </div>
        <div className="form-row">
          <label className="required">Password</label>
          <Field
            name="password"
            id="password"
            type="password"
            placeholder="Password"
            component={FormInput}
            validate={[required]}
          />
        </div>
        <div className="form-row with-checkbox">
          <Field
            labelText="Keep me logged in"
            name="keepLoggedIn"
            id="keepLoggedIn"
            type="checkbox"
            component={Checkbox}
          />
          <Link to="/forgot-password" className="forgot-password-link">Forgot password?</Link>
        </div>
        {loginErrors && <StyledErrorBlock>{loginErrors}</StyledErrorBlock>}
        <div className="form-action">
          <ButtonPrimary
            type="submit"
            buttonText="Continue"
            size="small"
            action={handleSubmit(setUser)}
          />
        </div>
      </div>
    </StyledForm>
  )
}
